import React from 'react';
import { IResourceComponentsProps } from '@refinedev/core';
import { Edit, useForm, useSelect } from '@refinedev/antd';
import { Form, Select, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

export const GoldRequestsEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm();

  const goldRequestsData = queryResult?.data?.data;

  const { selectProps: typeSelectProps } = useSelect({
    resource: 'type',
    optionLabel: 'name',
    optionValue: 'id',
  });

  const { selectProps: tierSelectProps } = useSelect({
    resource: 'tier',
    optionLabel: 'name',
    optionValue: 'id',
  });

  const { selectProps: segmentSelectProps } = useSelect({
    resource: 'segment',
    optionLabel: 'name',
    optionValue: 'id',
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          type: goldRequestsData?.type?.id || undefined,
          tier: goldRequestsData?.tier?.id || undefined,
          segment: goldRequestsData?.segment?.id || undefined,
        }}
      >
        <Form.Item
          label="Type"
          name={['type', 'id']}
          rules={[
            {
              required: false,
            },
          ]}
          initialValue={goldRequestsData?.type[0]?.type?.id}
        >
          <Select {...typeSelectProps} allowClear />
        </Form.Item>
        <Form.Item
          label="Tier"
          name={['tier', 'id']}
          rules={[
            {
              required: false,
            },
          ]}
          initialValue={goldRequestsData?.tier[0]?.tier?.id}
        >
          <Select {...tierSelectProps} allowClear />
        </Form.Item>
        <Form.Item
          label="Segment"
          name={['segment', 'id']}
          rules={[
            {
              required: false,
            },
          ]}
          initialValue={goldRequestsData?.segment[0]?.segment?.id}
        >
          <Select {...segmentSelectProps} allowClear />
        </Form.Item>

        <Form.Item
          label="Status"
          name={['is_deleted']}
          initialValue={goldRequestsData?.is_deleted}
          rules={[
            {
              required: false,
              message: 'Please select status',
            },
          ]}
        >
          <Select style={{ width: '200px' }}>
            <Select.Option value={false}>
              <Space>
                <CheckCircleOutlined style={{ color: 'green' }} />
                Active
              </Space>
            </Select.Option>
            <Select.Option value={true}>
              <Space>
                <CloseCircleOutlined style={{ color: 'red' }} />
                Inactive
              </Space>
            </Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Edit>
  );
};
